import { __awaiter } from "tslib";
import ApiManager from '@/managers/apimanagers';
import router from '@/router';
import { ref } from 'vue';
export const key = 'token';
export const MESSAGES = {
    INVALID: 'Invalid Email or password.',
    TOO_MANY_TRIALS: 'The specified number of trials has been exceeded. Try again later.',
    UNKNOWN: 'Sorry. Try again later.',
};
/**
 * @summary 認証機能
 */
export const useAuthenticate = () => {
    const isLoading = ref(false);
    /**
     * @summary ログイン処理
     * @param username ユーザ名
     * @param password パスワード
     */
    const onLogin = (username, password) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c;
        try {
            isLoading.value = true;
            const request = {
                email: username,
                password: password,
            };
            const response = yield ApiManager.post('/auth/login', request);
            if (!response || !response.access_token) {
                return MESSAGES.INVALID;
            }
            localStorage.setItem(key, response.access_token);
            router.push('/');
            return '';
        }
        catch (err) {
            if (((_a = err.response) === null || _a === void 0 ? void 0 : _a.status) === 400 || ((_b = err.response) === null || _b === void 0 ? void 0 : _b.status) === 401) {
                return MESSAGES.INVALID;
            }
            if (((_c = err.response) === null || _c === void 0 ? void 0 : _c.status) === 429) {
                return MESSAGES.TOO_MANY_TRIALS;
            }
            return MESSAGES.UNKNOWN;
        }
        finally {
            isLoading.value = false;
        }
    });
    /**
     * @summary ログアウト処理
     */
    const onLogout = (isAuth) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (isAuth) {
                yield ApiManager.post('/auth/logout', {});
            }
            localStorage.removeItem(key);
            location.href = '/members/sign_in';
        }
        catch (err) {
            return;
        }
    });
    /**
     * @summary 連携ログイン処理
     */
    const onConnect = (token) => __awaiter(void 0, void 0, void 0, function* () {
        var _d;
        if (!token) {
            return '';
        }
        try {
            isLoading.value = true;
            const response = yield ApiManager.post('/auth/connect', { token });
            localStorage.setItem(key, response.access_token);
            router.push('/');
            return '';
        }
        catch (err) {
            if (((_d = err.response) === null || _d === void 0 ? void 0 : _d.status) === 401) {
                return MESSAGES.UNKNOWN;
            }
            return MESSAGES.UNKNOWN;
        }
        finally {
            isLoading.value = false;
        }
    });
    /**
     * @summary ユーザーの認証判定
     */
    const isAuthenticate = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (!localStorage.getItem(key)) {
                return false;
            }
            const response = yield ApiManager.get('/auth/me');
            return response.email !== null && response.email !== undefined;
        }
        catch (err) {
            return false;
        }
    });
    /**
     * @summary ユーザー情報取得
     */
    const getUserInfo = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            if (!localStorage.getItem(key)) {
                return {
                    userInfo: null,
                    isAuth: false,
                };
            }
            const userInfo = yield ApiManager.get('/auth/me');
            return {
                userInfo: userInfo,
                isAuth: userInfo.email !== null && userInfo.email !== undefined,
            };
        }
        catch (err) {
            return {
                userInfo: null,
                isAuth: false,
            };
        }
    });
    const getToken = () => {
        return localStorage.getItem(key);
    };
    return { isLoading, onLogin, onLogout, onConnect, isAuthenticate, getUserInfo, getToken };
};
